// extracted by mini-css-extract-plugin
module.exports = {"item":"SideBarMenuElement_item__6reRt","img":"SideBarMenuElement_img__zx2dJ","itemSelected":"SideBarMenuElement_itemSelected__13TR0"};